// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"b00c003a","189":"e7615ec4","234":"6a303e4d","421":"e8552dd2","489":"2b4225c4","785":"15b5ed2b","963":"aa23628d"}[chunkId] + ".chunk.js";
};